




export const OjEvent = class Event {
    #name;
    #data;

    constructor (name, data) {
        if ( !name ) throw new Error('No name set');
        if ( !data ) throw new Error('No data set');

        this.#name = name;
        this.#data = data;
    }

    getName () {
        return this.#name;
    }



    /*
     * Trigger ojtag event
     */
    trigger () {
        window.ojtag(this.#name, this.#data);

        return this;
    }
}





export const OjEventManager = class EventManager {
    #events = {};



    addEvent (event) {
        if ( event instanceof OjEvent === false ) {
            throw new Error('Event has to be OjEvent');
        }

        this.#events[event.getName()] = event;

        return this;
    }



    trigger () {
        Object.values(this.#events)
            .forEach(event => event.trigger());
    }
}
